import { Box, Radio, RadioGroup, Stack } from '@chakra-ui/react';
import { UPDATE_TYPE_REPLACE, UPDATE_TYPE_UPDATE } from 'constants/uploadDownload';
import { FormattedMessage } from 'react-intl';

export default function UpdateTypeSelect({ updateType, setUpdateType, ...rest }) {
    return (
        <Box {...rest}>
            <RadioGroup onChange={setUpdateType} value={updateType}>
                <Stack direction="column" spacing={2}>
                    <Radio value={UPDATE_TYPE_UPDATE}>
                        <FormattedMessage id="upload_update" />
                    </Radio>
                    <Radio value={UPDATE_TYPE_REPLACE}>
                        <FormattedMessage id="upload_replace" />
                    </Radio>
                </Stack>
            </RadioGroup>
        </Box>
    );
}
